import apiClient from '../../../services/apiClient';

/**
 * Match-3 mission API (v1.42.0, server-authoritative, the client only sends swaps).
 * Contract: .claude/lair-feature/SPEC_V141_GAMES.md §11.3 / Match3StateDTO.
 * GET / POST return { state, events, run }:
 *   state  — { width, height, board[y][x], score, target, thresholds:[T,1.5T,2T], movesLeft, movesTotal,
 *              result: null|'WIN'|'LOSE', stars, hint: [[x1,y1],[x2,y2]]|null, gemBonus:{STR:1.1,…}, level }
 *            board cell: 'STR'|'AGI'|'INT'|'GOLD'|'GEM' or { gem, special: 'LINE_H'|'LINE_V'|'BOMB'|'RAINBOW' }
 *   events — playback events ([] on GET): swap, special, clear, fall, spawn, shuffle, end, timeout
 *   run    — MissionRunDTO with rewards once the game is over, else null
 */
export const match3API = {
  // GET /v1/missions/runs/{runId}/match3[?hint=1]
  getGame: async (runId, { hint } = {}) => {
    const url = `/v1/missions/runs/${runId}/match3`;
    const response = hint ? await apiClient.get(url, { params: { hint: 1 } }) : await apiClient.get(url);
    return response.data;
  },
  // POST /v1/missions/runs/{runId}/match3 { x1, y1, x2, y2 } — 422 if the swap makes no match
  swap: async (runId, a, b) => {
    const response = await apiClient.post(`/v1/missions/runs/${runId}/match3`, {
      x1: a[0], y1: a[1], x2: b[0], y2: b[1],
    }, { silentError: true }); // an invalid swap is a normal game event — no global alert
    return response.data;
  },
  // GET /v1/game/runs/{runId}/hero → { characterId, character, look }
  getHero: async (runId) => {
    const response = await apiClient.get(`/v1/game/runs/${runId}/hero`);
    return response.data;
  },
};

export default match3API;
